import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { UserControllerPutRequestConfigureOtpParameter } from '../parameters/user-controller-put-request-configure-otp.parameter';
import { UserControllerPutRequestConfigureOtpResponse } from '../responses/user-controller-put-request-configure-otp.response';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'legacy',
    operationId: 'user-controller-putRequestConfigureOtp',
    operation: '{"operationId":"user-controller-putRequestConfigureOtp","parameters":[{"name":"userUuid","in":"path","required":true,"schema":{"type":"string","format":"uuid"}}],"responses":{"200":{"content":{"application/json":{"schema":{"type":"object"}}}}},"method":"put","path":"/user-controller/{userUuid}/request-configure-otp"}'
  })
export class UserControllerPutRequestConfigureOtpRemoteMethod extends OpenApiRemoteMethod<UserControllerPutRequestConfigureOtpResponse, UserControllerPutRequestConfigureOtpParameter, void> {
  public override call(parameters: OpenApiRemoteMethodParameter<UserControllerPutRequestConfigureOtpParameter, void>): Promise<UserControllerPutRequestConfigureOtpResponse> {
    return super.call(parameters);
  }
}
